module.exports = __webpack_public_path__ + "login_bg.8860ca1a74814d19a0b1.png";


//////////////////
// WEBPACK FOOTER
// C:/Project/MDX/CoffeeKiosk_angular/src/assets/images/login_bg.png
// module id = ../../../../../src/assets/images/login_bg.png
// module chunks = 2